export default __webpack_public_path__ + "static/media/futuregrowth_2.f336bcea.png";